// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".react-rater{line-height:normal}.react-rater,.react-rater>*{display:inline-block}.react-rater-star{color:#ccc;cursor:pointer;position:relative}.react-rater-star.will-be-active{color:#666}.react-rater-star.is-active{color:#000}.react-rater-star.is-active-half:before{color:#000;content:\"★\";left:0;overflow:hidden;position:absolute;width:50%}.react-rater-star.is-disabled{cursor:default}", ""]);
// Exports
module.exports = exports;
